export default "__VITE_ASSET__BeCkXSEU__"